<template>
  <b-card>
    <fields layout="inline" />
  </b-card>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import debounce from 'lodash-es/debounce'
import moment from 'moment'

export default {
  name: 'Filters',
  mixins: [FormMixin],

  props: {
    period: {
      type: Object,
      default() {
        return {
          gte: moment()
            .subtract(7, 'd')
            .format('YYYY-MM-DD'),
          lte: moment().format('YYYY-MM-DD'),
        }
      },
    },
  },

  data: () => ({
    model: {
      period: {
        gte: moment()
          .subtract(7, 'd')
          .format('YYYY-MM-DD'),
        lte: moment().format('YYYY-MM-DD'),
      },
    },
  }),
  mounted() {
    this.model.period = this.period
    this.setFields([
      {
        attribute: 'period',
        component: 'date-range-field',
      },
    ])

    this.$watch(
      'model',
      debounce(() => {
        this.$emit('change', this.model)
      }, 1000),
      { deep: true },
    )
  },
}
</script>
